import { render, staticRenderFns } from "./MobileTab.vue?vue&type=template&id=2068334a&scoped=true"
import script from "./MobileTab.vue?vue&type=script&lang=js"
export * from "./MobileTab.vue?vue&type=script&lang=js"
import style0 from "./MobileTab.vue?vue&type=style&index=0&id=2068334a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068334a",
  null
  
)

export default component.exports